"use strict";
/**
 *
 *
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var next_tick_1 = __importDefault(require("next-tick"));
var Retainable = /** @class */ (function () {
    function Retainable() {
        this.__refCount = 1;
    }
    Retainable.prototype.retain = function () {
        this.__refCount++;
        return this;
    };
    Retainable.prototype.release = function () {
        if (this.__refCount <= 0) {
            // Error: might be already disposed
            debugger;
        }
        this.__refCount--;
        if (this.__refCount === 0) {
            this._dispose();
            return true;
        }
        else {
            return false;
        }
    };
    Retainable.prototype.releaseNextTick = function () {
        var _this = this;
        next_tick_1["default"](function () { return _this.release(); });
        return this;
    };
    /**
     * Memory management: save link to memory until provided function return result or throw error
     *
     *
     * @param {() => any} fn
     * @returns {Promise<any>}
     */
    Retainable.prototype.lock = function (fn) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.retain();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, fn()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        this.release();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Retainable;
}());
exports.Retainable = Retainable;
var safeMemWrap = function (fn, obj) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var o, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this) {
                            o = this; // method
                        }
                        else {
                            o = obj; // callback
                        }
                        if (o.__refCount <= 0) {
                            throw new Error('Trying to call method on disposed object');
                        }
                        o.retain();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, fn.apply(o, args)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        o.release();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
};
function memLock(target, key, descriptor) {
    // if (descriptor === undefined) {
    //   descriptor = Object.getOwnPropertyDescriptor(target, key);
    // }
    if (descriptor === undefined) {
        // in case of property assignment
        var value_1;
        if (target[key]) {
            value_1 = safeMemWrap(target[key], target);
        }
        Object.defineProperty(target, key, {
            get: function () { return value_1; },
            set: function (v) {
                return (value_1 = safeMemWrap(v, this));
            },
            enumerable: true
        });
        return null;
    }
    // method
    var originalMethod = descriptor.value;
    descriptor.value = safeMemWrap(originalMethod);
    return descriptor;
}
exports.memLock = memLock;
